const routes = {
  index: {
    path: 'index.consult.commande',
    url: '/commandes',
  },
  home: {
    path: 'index.consult.commande.home',
    url: '/accueil',
  },
  new: {
    path: 'index.consult.commande.new',
    url: '/creer',
  },
  edit: {
    path: 'index.consult.commande.edit',
    url: '/modifier',
  },
  details: {
    path: 'index.consult.commande.details',
    url: '/details',
  },
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/commande/routes.js